import {useCallback, useMemo} from 'react';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

const EXPERIMENT_DESKTOP = 'test_meganav_tabs_desktop';
const EXPERIMENT_MOBILE = 'test_meganav_tabs_mobile';

// bucketing is done via Jinja tempalte, therefore the readOnly property is always true here.
export const useNewMegaNavExperiment = () => {
  const isLargishAndUp = useIsLargishAndUp();
  const checkInVariant = useCallback(
    (testName: string) => evite.experiments.inVariation(testName, 'variant', false, true),
    []
  );

  const inDesktopExperiment = useMemo(
    () => isLargishAndUp && checkInVariant(EXPERIMENT_DESKTOP),
    [isLargishAndUp, checkInVariant]
  );

  const inMobileExperiment = useMemo(
    () => !isLargishAndUp && checkInVariant(EXPERIMENT_MOBILE),
    [isLargishAndUp, checkInVariant]
  );

  const inExperiment = inDesktopExperiment || inMobileExperiment;

  return {inExperiment, inDesktopExperiment, inMobileExperiment};
};
